import { TypeStorage } from '../../interfaces/TypeStorage/TypeStorage'
import { TypeStorageAction } from '../actions/typeStorageActions'
import { GET_TYPE_STORAGE_EXITO } from '../types/typeStorageActionstypes'

export interface TypeStorageState {
  typeStorageState: {
    typestorage?: TypeStorage[]
    error?: string | undefined
  }
}

const initialState: TypeStorageState = {
  typeStorageState: { typestorage: [], error: '' }
}

export const typeStorageReducer = (
  state: TypeStorageState = initialState,
  action: TypeStorageAction
): TypeStorageState => {
  if (action.type === GET_TYPE_STORAGE_EXITO) {
    return {
      ...state,
      typeStorageState: {
        typestorage: action.typeStorage,
        error: action.error
      }
    }
  }
  return state
}
